<ng-container 
	[ngTemplateOutlet]="viewDynamicItemsTemplate"
	[ngTemplateOutletContext]="{pos:0, items:dynamicAttributeItems}">
</ng-container>

<div *ngIf="documents && documents.length !== 0; else documentMetadataEmpty">
		<ng-container *ngFor="let document of documents">
			<div class="layoutBlock">
				<div class="columnDetailLabel detailPresentationListLabel">	
					<span>{{document.name}} <his-upload-file-download [value]="document"></his-upload-file-download></span>
				</div>
			</div>			
			<div class="layoutBlock">
				<div class="columnDetailLabel detailPresentationListLabel">	
					<span>{{'cs.sys.filemanagement.category' | hisUi}}</span>
				</div>
				<div class="columnDetailContent detailPresentationListContent">	
					{{ documentCategoriesMap.get(document.id) }}
				</div>
			</div>
			<div class="layoutBlock">
				<div class="columnDetailLabel detailPresentationListLabel">	
					<span>{{'fs.res.common.documents.DocumentMetada.mimedata.description' | hisUi}}</span>
				</div>
				<div class="columnDetailContent detailPresentationListContent">	
					{{document.comment}}
				</div>
			</div>
			<div class="layoutBlock">
				<div class="columnDetailLabel detailPresentationListLabel">	
					<span>{{'fs.res.common.documents.DocumentMetada.mimedata.createdAt' | hisUi}}</span>
				</div>
				<div class="columnDetailContent detailPresentationListContent">	
					{{document.createdAt | date : 'dd.MM.yyyy HH:mm'}}
				</div>
			</div><br>
		</ng-container>
	</div>
		<ng-template #documentMetadataEmpty>
			<div>
				<div [class]="'infoMessage'">
					{{ 'fs.res.common.documents.noDocumentsAssigned' | hisUi }}			
				</div>
			</div>
		</ng-template>

<ng-container 
	[ngTemplateOutlet]="viewDynamicItemsTemplate"
	[ngTemplateOutletContext]="{pos:1, items:dynamicAttributeItems}">
</ng-container>